import { validateAndFormat } from "../../common/addNew/validateAndFormat";

/**
 * Action for groups
 */
export const actions = {
  /**
   * Submit the form
   * @param {Object} context
   */
  async submitForm(context) {
    // Step 1: Start loading
    context.commit("setLoadingAddAppointment", true, {
      root: true
    });
    context.commit("addNew/setFormSubmitted", false, { root: true }); // Form not submitted

    // Step 1: Getting the selected provider id
    const selectedProviderId = context.rootGetters.getSelectedProviderID;

    // Step 2: Validate and format everything
    const name = validateAndFormat.name(
      context.rootGetters["addNew/getName"].firstName,
      context
    );
    const [groupList, users] = validateAndFormat.groupList(context);
    const isVideo = context.getters.getIsVideo === true;

    // Step 3: Check if everything is valid
    if (!name || !groupList) {
      // Step 3.1: Stop loading
      context.commit("addNew/setFormSubmitted", true, {
        root: true
      });
      context.commit("setLoadingAddAppointment", false, {
        root: true
      });

      // Step 3.2: Return
      return false;
    }

    // Step 4: Creating request data
    const requestData = {
      name: name,
      participants: groupList,
      providerID: selectedProviderId,
      isVideo: isVideo
    };

    /**
     * Step 5 Sending auth request
     *
     * Response format
     * {
     *   code: 200,
     *   group_appointment_id: 214 // The groupappointment_id
     * }
     */
    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: "groups/add",
        method: "POST",
        data: requestData
      },
      { root: true }
    );

    // Step 6: Insert into form details if required
    if ("group_appointment_id" in json) {
      const group = {
        id: json.group_appointment_id,
        is_video: isVideo,
        name: name,
        users
      };

      // Step 7: Add to form list
      context.commit(
        "addToGroupListInForm",
        { group, providerId: selectedProviderId },
        { root: true }
      );
    }

    // Step 8: Stop loading
    context.commit("addNew/setFormSubmitted", true, {
      root: true
    });
    context.commit("setLoadingAddAppointment", false, {
      root: true
    });

    // Step 9: Return
    return true;
  }
};
